module.exports = __webpack_public_path__ + "img/mercadopagologo.e64dff95.svg";